import { render, staticRenderFns } from "./StockRangeInput.vue?vue&type=template&id=508f63e4&"
import script from "./StockRangeInput.vue?vue&type=script&lang=ts&"
export * from "./StockRangeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports